import React from 'react'
import Pane from 'components/Common/Pane'
import Heading from 'LuxKit/Typography/Heading'
import PriceModeSelectMobile from 'components/OfferPage/Filters/PriceModeSelect/PriceModeSelectMobile'
import Group from 'components/utils/Group'
import { useIntl } from 'react-intl'

export const ROOM_MODE_TOGGLE_SECTION_ID = 'roomModeToggleSection'

interface Props {
  charterBundleRoute?: App.CharterBundleRoute
}

function OfferPagePackagesHeading({
  charterBundleRoute,
}: Props) {
  const intl = useIntl()
  return <Pane padding="20 20 16">
    <Group direction="horizontal" verticalAlign="center" horizontalAlign="space-between">
      <Heading variant="heading4">
        {intl.formatMessage({
          id: 'GMvdJuANFWObnCEYYJ1S',
          defaultMessage: 'Select a package',
          description: 'Heading for package selection section in multi-room booking',
        })}
      </Heading>
      {!!charterBundleRoute && <PriceModeSelectMobile />}
    </Group>
  </Pane>
}

export default OfferPagePackagesHeading
